module.exports = __webpack_public_path__ + "static/media/carrara-bol-webfont.bad476d5.woff2";